<template>
  <app-content class="asset-list">
    <div
      class="asset-list__header"
      slot="breadcrumb-custom"
    >
      <b-row
        class="asset-list__header-row"
        no-gutters
      >
        <b-col
          class="mb-4 mb-lg-0 px-lg-3"
          sm="12"
          md="6"
        >
            <span>
              {{ $t('asset-list.select-the-asset') }}
            </span>
        </b-col>
        <b-col
          class="asset-list__col-search-items"
          sm="12"
          md="6"
        >
          <s-search-input
            class="asset-list__search-input-group"
            v-model="searchTerm"
            :placeholder="$t('asset-list.query.search-placeholder')"
            @input="onInputHandler"
          />
          <s-sidebar
            class="asset-list__treeview"
            icon="account_tree"
          >
            <template #body>
              <treeview
                :tree="tree"
                @onClickNode="onClickNodeHandler"
              />
            </template>
          </s-sidebar>
        </b-col>
      </b-row>
    </div>
    <asset-list
      :items="items"
      :summary="summary"
      :loading="loading"
    />
    <grid-paginator
      :total-rows="totalItems"
      :per-page="perPage"
      v-model="currentPage"
      @input="paging()"
    />
  </app-content>
</template>

<script>
import { TreeviewLinkType } from 'sigma-mappings';
import { delayed } from '@/services/observables';
import GridPaginator from '@/components/lists/Paginator';
import Treeview from '@/components/treeview/Treeview';
import AssetList from '@/domain/components/generalPanel/assetList/List';
import AssetListService from '@/domain/services/generalPanel/assetsList/assetsListService';

const PER_PAGE_DEFAULT = 10;

export default {
  components: {
    AssetList,
    GridPaginator,
    Treeview,
  },
  data: vm => ({
    tree: [],
    searchTerm: '',
    appliedSearchOnLastTyping: false,
    loading: true,
    doDelayedRequest: delayed((...args) => vm.doRequest(...args)),
    currentPage: 1,
    totalItems: null,
    perPage: PER_PAGE_DEFAULT,
    summary: {},
    items: [],
  }),
  created() {
    AssetListService.getAssetsTreeviewList()
      .then((response) => {
        this.tree = response;
      });
    this.refreshItems();
  },
  methods: {
    onClickNodeHandler(node) {
      if (node.clickType === TreeviewLinkType.LINK) {
        const { id: assetId, installationId } = node;
        const routeData = this.$router.resolve({
          name: 'asset.asset-id',
          params: {
            installationId,
            assetId,
          },
        });
        window.open(routeData.href, '_blank');
      }
    },
    onInputHandler() {
      this.changingSearch();
    },
    changingSearch() {
      this.currentPage = 1;
      this.refreshItems();
    },
    async refreshItems() {
      this.items = [];
      this.loading = true;
      try {
        return await this.doDelayedRequest(this.getRequestFilter());
      } finally {
        this.loading = false;
      }
    },
    doRequest(requestFilter) {
      return AssetListService
        .getAssetsList(requestFilter)
        .then(result => this.getProjectRequestResult(result));
    },
    getProjectRequestResult(result) {
      this.items = result.data;
      this.summary = result.summary;
      this.totalItems = result.total;
      this.currentPage = result.page;
    },
    getRequestFilter() {
      return {
        filter: {
          installation: this.searchTerm,
        },
        page: this.currentPage,
        pageSize: this.perPage,
      };
    },
    paging() {
      this.refreshItems();
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.asset-list
  &__col-search-items
    display: flex
    justify-content: flex-end
    align-items: center
    padding: 0

  &__header
    max-width: 100%;
    margin: 0

  &__header-row
    display: flex
    justify-content: flex-end
    align-items: flex-end
    margin-bottom: 3px

  &__search-input-group
    width: 25rem
    padding-right: 1rem

  &__treeview
    position: relative
    top: .5rem

::v-deep
  .app-content__main-content
    padding-bottom: 0
    justify-content: space-between

  .app-breadcrumb__custom-content
    padding-left: 0

+media-max-md()
  ::v-deep
    .app-breadcrumb
      flex-direction: column
      align-items: flex-start

  .asset-list
    &__search-input-group
      width: 100%
</style>
